module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/full-print/2-1-efc5e28867d8e288294abda1e036bf49.jpg";